import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Checkbox as Component, CheckboxProps } from 'antd';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface StyledCheckboxProps {
  fillColor?: string;
  disabledColor?: string;
  rebrandProviderWebAppPhase3?: boolean;
}

const StyledCheckbox = styled(Component)<StyledCheckboxProps>`
  font-size: 16px;

  .ant-checkbox-inner,
  .ant-checkbox,
  .ant-checkbox:hover {
    border-radius: 4px !important;
  }

  .ant-checkbox-disabled + span {
    ${props =>
      props.disabledColor &&
      css`
        color: ${props.disabledColor} !important;
      `}
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${props => (props.rebrandProviderWebAppPhase3 ? '#1e61e6' : '#137ac9')};
    border-color: ${props => (props.rebrandProviderWebAppPhase3 ? '#1e61e6' : '#137ac9')};
    ${props =>
      props.fillColor &&
      css`
        border-color: ${props.fillColor};
        background-color: ${props.fillColor};
      `}
  }

  &:hover .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {
    border-color: #e0e0e0 !important;
    background: #efefef !important;
    border-radius: 4px !important;
  }

  span:last-child {
    word-break: break-word;
  }
`;

type ForwardRefCheckboxProps = CheckboxProps & StyledCheckboxProps;
const ForwardRefCheckbox = forwardRef<HTMLInputElement, ForwardRefCheckboxProps>((props, ref) => {
  const { rebrandProviderWebAppPhase3 } = useFlags();

  return <StyledCheckbox rebrandProviderWebAppPhase3={rebrandProviderWebAppPhase3} {...props} ref={ref} />;
});

type CheckboxType = typeof ForwardRefCheckbox & { Group?: typeof Component.Group };
const Checkbox: CheckboxType = ForwardRefCheckbox;
Checkbox.Group = Component.Group;

export default Checkbox;
